import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import CertificatePicker from './CertificatePicker';

export default function ExpiryGroupCard({
  group,
  groupIndex,
  certificates,
  getCertNameById,
  searchFilter,
  customIdValue,
  onSearchFilterChange,
  onCustomIdChange,
  onAddCustomId,
  onNameChange,
  onToggleFlag,
  onToggleCert,
  onSelectAll,
  onDeselectAll,
  onRemove,
}) {
  return (
    <Card variant="outlined" sx={{ mb: 2, p: 2, bgcolor: 'background.default' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
        <TextField
          size="small"
          label={`Group ${groupIndex + 1} name`}
          value={group.name}
          onChange={(e) => onNameChange(e.target.value)}
          sx={{ width: 240 }}
        />
        <Button size="small" color="error" onClick={onRemove}>
          Remove
        </Button>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={group.includeExpiry}
              onChange={(e) => onToggleFlag('includeExpiry', e.target.checked)}
            />
          }
          label={<Typography variant="body2">Must not be expired</Typography>}
        />
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={group.includeIsActive}
              onChange={(e) => onToggleFlag('includeIsActive', e.target.checked)}
            />
          }
          label={<Typography variant="body2">Must be active</Typography>}
        />
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={group.includeApproved}
              onChange={(e) => onToggleFlag('includeApproved', e.target.checked)}
            />
          }
          label={<Typography variant="body2">Approved only</Typography>}
        />
      </Box>

      <CertificatePicker
        certificates={certificates}
        selectedCertIds={group.certIds}
        onToggleCert={onToggleCert}
        onSelectAll={onSelectAll}
        onDeselectAll={onDeselectAll}
        loading={false}
        searchFilter={searchFilter}
        onSearchFilterChange={onSearchFilterChange}
        customIdValue={customIdValue}
        onCustomIdChange={onCustomIdChange}
        onAddCustomId={onAddCustomId}
        getCertNameById={getCertNameById}
        emptyMessage="No certificates loaded."
        maxHeight={200}
      />
    </Card>
  );
}
